import React , {useEffect} from 'react'
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import Aos from "aos";
import 'aos/dist/aos.css';
import MainMap from '../MainMap';

const MapContainer = styled.div`
  display:flex;
  flex-direction: column;
  margin-bottom: 100px;
  overflow-x: hidden;

  @media (max-width: 480px) {
    font-size: 18px;
    margin-bottom: 80px;
    place-self:center;
  }
`;

const Title = styled.div`
   font-size: 40px;
   display:flex;
   color: #385963;
   font-weight: 600;
   margin-bottom: 10px;

  @media (max-width: 768px) {
    font-size: 25px;
    margin-bottom: 20px;
    place-self:center;
  }

  @media (max-width: 480px) {
    font-size: 18px;
    margin-bottom: 20px;
    place-self:center;
  }
`;

const Description = styled.div`
   font-size: 20px;
   margin-bottom: 20px;
   color:#91abb3;

 
  @media (max-width: 768px) {
    font-size: 14px;
    margin: 10px 20px 80px;
    text-align:center;
  }

  @media (max-width: 480px) {
    font-size: 12px;
    margin: 10px 10px 50px;
    text-align:center;
  }
`;

const Image = styled.img`
   height: 500px;
   width: auto;
`;

const Container = styled.div`

`;

const InteractiveMapHome = () => {

   useEffect(()=>{
      Aos.init({duration:1000})
    },[]);

    const { i18n } = useTranslation();

  return (
    <MapContainer>
       <Title data-aos="zoom-in-down">{i18n.t('interactiveMap')}</Title>
       <Description data-aos="fade-right">{i18n.t('interactiveMapDescription')}</Description>
       
       <Container>
       <MainMap data-aos="fade-right"/>
       </Container>
    </MapContainer>
  )
}

export default InteractiveMapHome
